import {
  useDeleteSalesPromoPrize,
  useGetSalesPromoPrizeList,
  useSaveSalesPromoGeneral,
} from '../../../providers/SalesPromo.provider'

export function useSalesPromoForm2(campaign_id: string) {
  const prizeList = useGetSalesPromoPrizeList(campaign_id)
  const deletePrize = useDeleteSalesPromoPrize(campaign_id)
  const saveSalesPromoGeneral = useSaveSalesPromoGeneral()

  return {
    prizeList,
    deletePrize,
    saveSalesPromoGeneral,
  }
}
